











export default
  name: 'Widgets'
  components:
    forecast: require('components/inside/elements/forecast.vue').default
